import { Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { InstrumentDimension } from "../psyEvaluations.types";

type InstrumentDimensionsScoresProps = {
	dimensions: Array<InstrumentDimension>;
	entityForm: UseFormReturn;
	isLoading: boolean;
};

export const InstrumentDimensionsScores = ({ dimensions, entityForm, isLoading }: InstrumentDimensionsScoresProps) => {
	return (
		<Box p={2} sx={{ backgroundColor: "#fff" }}>
			<Typography variant="subtitle1" color="primary" fontWeight="bold" pb={3}>
				Dimensões
			</Typography>
			{isLoading && <CircularProgress color="secondary" size={24} />}
			{!isLoading && dimensions.length === 0 && (
				<Typography color="text.secondary">Este instrumento não tem dimensões.</Typography>
			)}
			{!isLoading && dimensions.length > 0 && (
				<TableContainer component={Paper} variant="outlined">
					<Table sx={{ tableLayout: "fixed" }}>
						<TableHead>
							<TableRow>
								<TableCell sx={{ width: "15%" }}>Dimensão</TableCell>
								<TableCell sx={{ width: "75%" }}>Descrição</TableCell>
								<TableCell sx={{ width: "10%" }}>Pontuação bruta</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{dimensions.map((dimension) => (
								<TableRow key={dimension.id}>
									<TableCell>{dimension.name}</TableCell>
									<TableCell>{dimension.description}</TableCell>
									<TableCell>
										<TextField
											fullWidth
											size="small"
											type="number"
											variant="outlined"
											inputProps={{ step: "any" }}
											{...entityForm.register(`scores.${dimension.id}`)}
										/>
									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			)}
		</Box>
	);
};
